import { employeeMiniProfile } from 'interfaces/EmployeeMiniProfile';
import { OneOnOneRequestI } from 'screens/oneOnOneRabbit/interfaces/common';
import { z } from 'zod';
import { generateErrorMessage } from 'zod-error';

import {
  cancelOneOnOneMeetingApi,
  getOneOnOneInstanceDetailsApi,
  updateOneOnOneInstanceDetailsApi,
  archiveOneOnOneMeetingApi,
  getOneOnOneInstanceDetailsFromMasterIdApi,
  completeMeetingApi,
} from '../apis';

export const INVALID_DATE_ERROR = 'INVALID_DATE';

export const oneOnOneDetailsValidator = z.object({
  orgId: z.number(),
  masterId: z.number(),
  recurrenceRule: z.string(),
  latestInstanceId: z.number().nullable().optional(),
  isArchived: z.boolean(),
  instanceId: z.number(),
  isShowRating: z.boolean(),
  //   providerEmployeeId: z.number(), // remove
  //   receiverEmployeeId: z.number(), // remove
  employeeDetails: employeeMiniProfile.nullable(),
  relationType: z.enum(['MANAGER', 'SKIP_MANAGER', 'PEER', 'SKIP_REPORTEE', 'REPORTEE']),
  // startTime: z.coerce.date(),
  startTimeTs: z.number().nullable(),
  duration: z.number().nullable(),
  completionTime: z.coerce.date().nullable(),
  completionStatus: z.enum(['YET_TO_START', 'CANCELLED', 'COMPLETED']),
  statusChangeSource: z
    .enum(['USER', 'COMPLETE_UI', 'CANCEL_UI', 'JOB', 'API_FIX', 'INITIAL', 'CANCEL_GOOGLE', 'CANCEL_OUTLOOK'])
    .nullable()
    .optional(),
  statusChangedBy: employeeMiniProfile.nullable().optional(),
  // rating: z.number().nullable(),
  // agendaItems: z.array(OneOnOneAgenda.nullable()).nullable(),
  // actionItems: z.array(OneOnOneActionItem.nullable()).nullable(),
  // privateNotes: OneOnOneNotes.nullable(),
  // sharedNotes: OneOnOneNotes.nullable(),
  meetingLink: z.string().nullable(),
  receiverEmployee: employeeMiniProfile.nullable(),
});

export const getOneOnOneInstanceDetails = async ({ masterId, instanceId }: OneOnOneRequestI) => {
  try {
    const res = await getOneOnOneInstanceDetailsApi({ masterId, instanceId });
    const data = oneOnOneDetailsValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error fetching one on one instance details ', error);
    // throw new Error(generateErrorMessage(error));
  }
};

export const getOneOnOneInstanceDetailsFromMasterId = async ({ masterId }: OneOnOneRequestI) => {
  try {
    const res = await getOneOnOneInstanceDetailsFromMasterIdApi({ masterId });
    const data = oneOnOneDetailsValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error fetching one on one instance details ', error);
    // throw new Error(generateErrorMessage(error));
  }
};

export type updateOneOnOneDetailsI = {
  isEditSingleMeeting: boolean;
  startDate: string;
  duration: number;
  startTimeTs: number;
  recurrenceRule: string;
};

export const updateOneOnOneInstanceDetails = async ({
  masterId,
  instanceId,
  duration,
  isEditSingleMeeting,
  recurrenceRule,
  startDate,
  startTimeTs,
}: updateOneOnOneDetailsI & OneOnOneRequestI) => {
  try {
    const res = await updateOneOnOneInstanceDetailsApi({
      masterId,
      instanceId,
      duration,
      isEditSingleMeeting,
      recurrenceRule,
      startDate,
      startTimeTs,
    });
    const data = oneOnOneDetailsValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error updating one on one instance details ', error);
    if (error.status === 400) {
      const newError = new Error();
      newError.message = error.message;
      newError.name = INVALID_DATE_ERROR;
      throw newError;
    }
    throw new Error(generateErrorMessage(error));
  }
};

export const cancelOneOnOneMeeting = async ({ masterId, instanceId }: OneOnOneRequestI) => {
  try {
    const res = await cancelOneOnOneMeetingApi({
      masterId,
      instanceId,
    });
    const data = oneOnOneDetailsValidator.parse(res.entity);
    return data;
  } catch (error) {
    console.error('Error updating one on one instance details ', error);
    // throw new Error(generateErrorMessage(error));
  }
};

export const archiveOneOnOneMeeting = async ({
  masterId,
  // instanceId,
  isArchive,
}: OneOnOneRequestI) => {
  try {
    const res = await archiveOneOnOneMeetingApi({
      masterId,
      // instanceId,
      isArchive,
    });
    const data = res.entity;
    return data;
  } catch (error) {
    console.error('Error archiving one on one instance  ', error);
    throw new Error(error.message);
  }
};

export const completeMeeting = async ({ masterId }: OneOnOneRequestI) => {
  try {
    const res = await completeMeetingApi({
      masterId,
    });
    const data = res.entity;
    return data;
  } catch (error) {
    console.error('Error completing one on one instance  ', error);
  }
};
